import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { CustomDatePicker, CustomDatePickerProps } from '../../../custom_shared/components';
import { WithInput } from '../../types';
import { useInputHighlighting, useGlobalInputState } from '../../hooks';

export type CustomDatePickerWrapperProps = WithInput<CustomDatePickerProps>;

const CustomDatePickerWrapper: React.FC<CustomDatePickerWrapperProps> = (props: CustomDatePickerWrapperProps) => {
    const { input, ...rest } = props;

    const [containerRef, setContainerRef] = React.useState<React.RefObject<HTMLDivElement> | null>(null);

    const { containerStyle } = useInputHighlighting(input, containerRef);

    const globalInputState = useGlobalInputState(input, props);

    return (
        <CustomDatePicker
            containerStyle={containerStyle}
            getContainerRef={setContainerRef}
            {...rest}
            {...globalInputState}
        />
    );
};

export default observer(CustomDatePickerWrapper);
